<template>
	<header class="bg-surface pt-4">
		<div class="row g-2 align-items-center">
			<div class="col-12 lh-1" :class="{ 'col-md-8': !!$slots.actions }" v-if="$slots.title">
				<slot name="title" />
			</div>
			<div class="col-12 text-md-end" :class="{ 'col-md-4': !!$slots.title }" v-if="$slots.actions">
				<slot name="actions" />
			</div>
		</div>
	</header>
</template>